import React, { useState, useEffect } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'
import ds from '../../../Services/DataServices'
import { useHistory } from 'react-router'
import {
  Card,
  Table,
  Button,
  Row,
  Col,
  Spin,
  Breadcrumb,
  DatePicker,
  Modal,
  Form,
  Divider,
  message,
  Avatar
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { REPORT_CLOSURE } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  isEmptyObject,
  checkRightspermissions,
  getDecryptID,
  notAllowMsgCheck,
  formatDigits
} from '../../../appRedux/actions/GlobalMethods'
import moment from 'moment'
import { FundViewOutlined } from '@ant-design/icons'
import InfoToPrint from '../../../components/InfoToPrint'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'
const Summary = props => {
  const { id } = props.match.params
  const dispatch = useDispatch()
  const history = useHistory()
  const [form] = Form.useForm()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )

  const [getIsLoading, setIsLoading] = useState(true)
  const [getData, setData] = useState({})
  const [getCashMove, setCashMove] = useState([])
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [showTaxes, setShowTaxes] = useState(false)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [layByList, setLayByList] = useState([])
  const [layByPaid, setLayByPaid] = useState([])
  const [onAccList, setOnAccList] = useState([])
  const [onAccPaid, setOnAccPaid] = useState([])
  const [returnSales, setReturnSales] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })

  useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!checkIsWeb().exist) {
        postDataToApp(PostAppTypes.PAGE_HEADER, 'report.register.summary')
      }

      dispatch(setCommonConfigs(REPORT_CLOSURE))
      if (id) {
        getRegClosureSummaryService({ CashRegPaymentID: id }, PkgFeatures.ReportingAndAnalytics)
      } else {
        setIsLoading(false)
        message.warn('Something is wrong')
        setTimeout(() => {
          history.push('/dashboard/reporting/registerclosures/listing')
        }, 2000)
      }
    }
    return () => (mounted = false)
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  async function getRegClosureSummaryService (body, featureID) {
    await ds
      .getRegClosureSummary(body, BEHAVIOUR_TYPE.GET, featureID)
      .then(data => {
        setIsLoading(false)
        if (data && !isEmptyObject(data)) {
          setData(data)
          if (data.cashMovements && data.cashMovements.length > 0) {
            let cashMove = data.cashMovements.map((e, key) => {
              return {
                id: key,
                cashManageID: e.cashManageID,
                pid: e.pid,
                user: e.userName,
                time: e.createdOn,
                reason: e.reason,
                amount: e.transaction
                  ? formatDigits(e.transaction, getDecimalPlaces)
                  : parseFloat('0.00'),
                note: e.note,
                email: e.userEmail,
                date: e.createdOnDate,
                nameLetter: e.lettersName,
                role: e.roleName,
                closingFloat: e.closingFloat
                  ? formatDigits(e.closingFloat, getDecimalPlaces)
                  : parseFloat('0.00')
              }
            })
            setCashMove(cashMove)
          } else {
            setCashMove([])
          }

          if (data.layby && data.layby.length > 0) {
            let totalLayBy = 0
            data.layby.map(a => {
              totalLayBy += a.amount
            })
            data.layby.push({
              id: 'xx',
              label: 'Total Laybys',
              value: formatDigits(totalLayBy, getDecimalPlaces)
            })
            setLayByList(data.layby)
          } else setLayByList([])

          if (data.laybyPaid && data.laybyPaid.length > 0) {
            let totalLayByPaid = 0
            data.laybyPaid.map(a => {
              totalLayByPaid += a.amount
            })
            data.laybyPaid.push({
              id: 'xx',
              label: 'Total Layby payments',
              value: formatDigits(totalLayByPaid, getDecimalPlaces)
            })
            setLayByPaid(data.laybyPaid)
          } else setLayByPaid([])

          if (data.onAccount && data.onAccount.length > 0) {
            let totalAcc = 0
            data.onAccount.map(a => {
              totalAcc += a.amount
            })
            data.onAccount.push({
              id: 'xx',
              label: 'Total On Account',
              value: formatDigits(totalAcc, getDecimalPlaces)
            })
            setOnAccList(data.onAccount)
          } else setOnAccList([])

          if (data.onAccountPaid && data.onAccountPaid.length > 0) {
            let totalAccPaid = 0
            data.onAccountPaid.map(a => {
              totalAccPaid += a.amount
            })
            data.onAccountPaid.push({
              id: 'xx',
              label: 'Total On Account Payments',
              value: formatDigits(totalAccPaid, getDecimalPlaces)
            })
            setOnAccPaid(data.onAccountPaid)
          } else setOnAccPaid([])

          if (data.returnSales && data.returnSales.length > 0) {
            let returnTotalPaid = 0
            data.returnSales.map(a => {
              returnTotalPaid += a.amount
            })
            data.returnSales.push({
              id: 'xx',
              label: 'Total New Returns',
              value: formatDigits(returnTotalPaid, getDecimalPlaces)
            })
            setReturnSales(data.returnSales)
          } else setReturnSales([])
        } else {
          setData({})
          setCashMove([])
          setReturnSales([])
          setOnAccPaid([])
          setOnAccList([])
          setLayByPaid([])
          setLayByList([])
        }
      })
      .catch(e => {
        setIsLoading(false)
        notAllowMsgCheck(e)
      })
  }

  function evenOrOdd (num) {
    //for string length take string
    if (num % 2 == 0) {
      //and replace numm with string.length here
      return 'even'
    } else {
      return 'odd'
    }
  }

  const payColumns = [
    {
      title: 'Payment Type',
      dataIndex: 'paymentType',
      key: 'paymentType',
      render: (text, record) => {
        return <strong style={{ color: '#1890ff' }}>{text}</strong>
      }
    },
    {
      title: 'Expected',
      dataIndex: 'expected',
      key: 'expected',
      render: (text, record) => {
        return <span>{formatDigits(text, getDecimalPlaces)}</span>
      }
    },
    {
      title: 'Counted',
      dataIndex: 'counted',
      key: 'counted',
      render: (text, record) => {
        return <span>{formatDigits(text, getDecimalPlaces)}</span>
      }
    },
    {
      title: 'Difference',
      dataIndex: 'difference',
      key: 'difference',
      render: (text, record) => {
        return <span>{formatDigits(text, getDecimalPlaces)}</span>
      }
    }
  ]

  const cashColumns = [
    {
      title: <IntlMessages id='sell.openclose.cashcol1' />,
      dataIndex: 'time',
      key: 'time',
      render: (text, record) => {
        let date = ''
        if (record.time) {
          if (record.time.includes('T')) {
            date = record.time.split('T')[1]
          }
        }
        return (
          <div className='ml-2'>
            <Row>
              <Col>
                <p className='mb-0'>
                  <strong> {record.date} </strong>
                </p>
              </Col>
            </Row>

            <Row>
              <Col>
                <p className='mb-0 date-cashmov'>
                  <strong> {date} </strong>
                </p>
              </Col>
            </Row>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='sell.openclose.cashcol2' />,
      dataIndex: 'user',
      key: 'user',
      render: (text, record, key) => {
        // let isEvenOrOdd = evenOrOdd(key);
        return (
          <>
            <span>{text}</span>
          </>
        )
      }
    },
    {
      title: <IntlMessages id='sell.openclose.cashcol3' />,
      dataIndex: 'amount',
      key: 'amount',
      render: (text, record) => {
        let isOut = false
        if (record.reason == 'CO' || record.reason == 'PCO') {
          isOut = true
        }
        return (
          <h5
            className='gx-link'
            style={{
              fontWeight: '700',
              color: isOut ? 'rgb(215, 113, 115)' : '#41af4b'
            }}
          >
            {isOut ? '-' : ''}
            {text ? text : '0.00'}
            {getCurrData.currencySymbol}
          </h5>
        )
      }
    },
    {
      title: <IntlMessages id='sell.openclose.cashcol4' />,
      key: 'reason',
      dataIndex: 'reason',
      render: (text, record) => {
        return (
          <div>
            <Row>
              <Col>
                <p className='mb-0 date-cashmov'>
                  <strong>
                    {record.reason == 'OF' ? (
                      <>
                        <IntlMessages id='sell.cashlisting.openingfloat' />
                      </>
                    ) : record.reason == 'CI' ? (
                      <>
                        <IntlMessages id='sell.cashlisting.cashin' />
                      </>
                    ) : record.reason == 'CO' ? (
                      <>
                        <IntlMessages id='sell.cashlisting.cashout' />
                      </>
                    ) : record.reason == 'PCI' ? (
                      <>
                        <IntlMessages id='sell.cashlisting.pettycashin' />
                      </>
                    ) : record.reason == 'PCO' ? (
                      <>
                        <IntlMessages id='sell.cashlisting.pettycashout' />
                      </>
                    ) : (
                      <></>
                    )}
                  </strong>
                </p>
              </Col>
            </Row>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='customer.addCustomer.note' />,
      dataIndex: 'note',
      key: 'note',
      render: (text, record) => {
        return <span>{text}</span>
      }
    }
  ]

  const accColumns = [
    {
      title: <IntlMessages id='products.promoadd.formdate' />,
      dataIndex: 'date',
      key: 'date',
      render: (text, record) => {
        return (
          <div className='ml-2'>
            <Row>
              <Col>
                <h5
                  className='gx-link'
                  style={{ fontWeight: '500' }}
                  onClick={() =>
                    history.push(
                      `/dashboard/sell/salehistory/sale/${record.saleOrderID}/1`
                    )
                  }
                >
                  {text ? moment(text).format('YYYY-MM-DD HH:mm a') : ''}
                </h5>
              </Col>
            </Row>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='setup.salesTax.addEditRegisterSubTitle2' />,
      dataIndex: 'receipt',
      key: 'receipt',
      render: (text, record, key) => {
        return (
          <>
            <span>{text}</span>
          </>
        )
      }
    },
    {
      title: <IntlMessages id='sell.cashlisting.col2' />,
      dataIndex: 'user',
      key: 'user',
      render: (text, record) => {
        return <h5>{text}</h5>
      }
    },
    {
      title: <IntlMessages id='sell.salehistory.col2' />,
      key: 'customer',
      dataIndex: 'customer',
      render: (text, record) => {
        return (
          <h5
            className='gx-link'
            style={{ fontWeight: '500' }}
            onClick={() => {
              history.push(
                `/Dashboard/customers/addcustomer/cusID=${record.customerID}`
              )
            }}
          >
            {text}
          </h5>
        )
      }
    },
    {
      title: <IntlMessages id='customer.addCustomer.note' />,
      dataIndex: 'note',
      key: 'note',
      render: (text, record) => {
        return <span>{text}</span>
      }
    },
    {
      title: '',
      dataIndex: 'xx',
      key: 'xx',
      render: (text, record) => {
        return record.id && record.id == 'xx' && <strong>{record.label}</strong>
      }
    },
    {
      title: <IntlMessages id='sell.salehistory.col5' />,
      dataIndex: 'amount',
      key: 'amount',
      render: (text, record) => {
        return record.id && record.id == 'xx' ? (
          <strong>{record.value}</strong>
        ) : (
          <span>{formatDigits(text, getDecimalPlaces)}</span>
        )
      }
    }
  ]

  return getIsAllowRead ? (
    <Spin
      tip={<IntlMessages id='sell.cashlisting.cashloading' />}
      spinning={getIsLoading}
      size='large'
    >
      <div className='Content-wrapper'>
        <Breadcrumb separator='>'>
          <Breadcrumb.Item>
            <span>
              <IntlMessages id='discount.inventory' />
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item
            className='custom-stock-hoverbreadcrumb'
            onClick={() =>
              history.push('/dashboard/reporting/registerclosures')
            }
          >
            <span>
              <IntlMessages id='discount.reporting.closure' />
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              <IntlMessages id='sell.openclose.printsubhead' />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

        <Row className='align-items-center mb-3 RegisterClosureSummary-header'>
          {checkIsWeb().exist && (
            <Col lg={12} md={12} sm={24} xs={24}>
              <h2 className='mb-0'>
                <IntlMessages id='sell.openclose.printsubhead' />
              </h2>
            </Col>
          )}

          <Col
            lg={checkIsWeb().exist ? 12 : 24}
            md={checkIsWeb().exist ? 12 : 24}
            sm={24}
            xs={24}
          >
            <div className='d-flex align-items-center justify-content-end mt-10-md'>
              {getData && getData.cashRegPayID && (
                <InfoToPrint
                  role='RegSummary'
                  regSummaryCashID={getData.cashRegPayID}
                  showExtraPrinters={
                    // !checkIsWeb().exist
                    //   ? localStorage.getItem('extraPrints') &&
                    //     localStorage.getItem('extraPrints') == '1'
                    //     ? true
                    //     : false
                    //   : false
                    !checkIsWeb().exist && localStorage.getItem('is_mob_app')
                      ? true
                      : false
                  }
                  isOpen={getData.isOpen ? '1' : '0'}
                />
              )}

              <Button
                className=''
                type='primary'
                size='large'
                onClick={() => {
                  history.push(
                    `/dashboard/reporting/registerclosures/detail/${id}`
                  )
                }}
                icon={<FundViewOutlined className='dk-btn-icon-align' />}
              >
                <IntlMessages id='discount.reporting.detail' />
              </Button>
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Card className='gx-card'>
              <div className='dk-last-closer-main Register-Summary-Div View-Stock-div'>
                <div className='dk-reg-closing'>
                  <h3
                    style={{ color: '#6692b0' }}
                    className='dk-reg-closing-flex'
                  >
                    <IntlMessages id='sell.openclose.regdetail2' />
                  </h3>
                  <p>{`${getData.register ? getData.register : ''}`}</p>
                </div>
                <div className='dk-reg-closing'>
                  <h3
                    style={{ color: '#6692b0' }}
                    className='dk-reg-closing-flex'
                  >
                    <IntlMessages id='discount.reporting.sequence' />
                  </h3>
                  <p>{getData.hash ? getData.hash : ''}</p>
                </div>
                <div className='dk-reg-closing'>
                  <h3
                    style={{ color: '#6692b0' }}
                    className='dk-reg-closing-flex'
                  >
                    <IntlMessages id='sell.openclose.regdetail1' />
                  </h3>
                  <p>{getData.outlet ? getData.outlet : ''}</p>
                </div>
                <div className='dk-reg-closing'>
                  <h3
                    style={{ color: '#6692b0' }}
                    className='dk-reg-closing-flex'
                  >
                    <IntlMessages id='setup.salesTax.mainRegister.col1' />:
                  </h3>

                  <p>
                    {getData.timeOpened
                      ? moment(getData.timeOpened).format('MMMM DD/YYYY h:mma')
                      : ''}
                  </p>
                </div>
                <div className='dk-reg-closing'>
                  <h3
                    style={{ color: '#6692b0' }}
                    className='dk-reg-closing-flex'
                  >
                    <IntlMessages id='setup.salesTax.mainRegister.col2' />:
                  </h3>

                  <p>
                    {!getData.isOpen
                      ? moment(getData.timeClosed).format('MMMM DD/YYYY h:mma')
                      : 'Still Open'}
                  </p>
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        <Card
          title={
            <h2 className='mb-0'>
              <IntlMessages id='discount.reporting.sales' />
            </h2>
          }
        >
          <Row>
            <Col span={12}>
              <h4>
                <IntlMessages id='discount.reporting.newsales' />
              </h4>
            </Col>

            <Col style={{ textAlign: 'end' }} span={12}>
              <h4>
                {`${getCurrData.currencySymbol} 
                  ${
                    getData.totalSales
                      ? formatDigits(getData.totalSales, getDecimalPlaces)
                      : '0.00'
                  }`}
              </h4>
            </Col>
          </Row>

          {getData.sales &&
            getData.sales.length > 0 &&
            getData.sales.map((e, i) => {
              return (
                <Row key={i} style={{ marginLeft: '18px' }}>
                  <Col span={12}>
                    <h4 style={{ marginLeft: '12px' }}>{e.name}</h4>
                  </Col>

                  <Col style={{ textAlign: 'end' }} span={12}>
                    <h4>
                      {`${getCurrData.currencySymbol} 
                    ${
                      e.total ? formatDigits(e.total, getDecimalPlaces) : '0.00'
                    }`}
                    </h4>
                  </Col>
                </Row>
              )
            })}

          <Row style={{ marginLeft: '18px' }}>
            <Col span={12}>
              <h3 style={{ marginLeft: '12px' }}>
                <a
                  onClick={() => setShowTaxes(!showTaxes)}
                  style={{ color: '#06c' }}
                >
                  Total Tax
                  {getData.taxes && getData.taxes.length > 0 && (
                    <>
                      {`(${getData.taxes.length} ${
                        getData.taxes.length > 1 ? 'Taxes' : 'Tax'
                      })`}
                      <i
                        className='icon icon-menu-up gx-fs-sm'
                        style={{
                          transform: 'rotate(180deg)',
                          display: !showTaxes ? 'inline-block' : ''
                        }}
                      ></i>
                    </>
                  )}
                </a>
              </h3>
            </Col>

            <Col style={{ textAlign: 'end' }} span={12}>
              <h4>
                {`${getCurrData.currencySymbol} 
                ${
                  getData.totalTax
                    ? formatDigits(getData.totalTax, getDecimalPlaces)
                    : '0.00'
                }`}
              </h4>
            </Col>
          </Row>

          {showTaxes &&
            getData.taxes &&
            getData.taxes.length > 0 &&
            getData.taxes.map((r, i) => {
              return (
                <Row key={i} style={{ marginLeft: '18px' }}>
                  <Col span={12}>
                    <h4
                      style={{ marginLeft: '12px', color: '#00000082' }}
                    >{`Tax (${r.taxName})`}</h4>
                  </Col>

                  <Col style={{ textAlign: 'end' }} span={12}>
                    <h4 style={{ color: '#00000082' }}>
                      {`${getCurrData.currencySymbol} 
                    ${r.tax ? formatDigits(r.tax, getDecimalPlaces) : '0.00'}`}
                    </h4>
                  </Col>
                </Row>
              )
            })}

          <Divider />

          <Row>
            <Col span={12}>
              <h4 style={{ marginLeft: '6px' }}>
                <IntlMessages id='discount.reporting.discounts' />
              </h4>
            </Col>

            <Col style={{ textAlign: 'end' }} span={12}>
              <h4>
                {`${getCurrData.currencySymbol} 
                  ${
                    getData.totalDiscount
                      ? formatDigits(getData.totalDiscount, getDecimalPlaces)
                      : '0.00'
                  }`}
              </h4>
            </Col>
          </Row>
          <Divider />

          <Row>
            <Col span={12}>
              <h4 style={{ marginLeft: '6px' }}>
                <IntlMessages id='discount.reporting.payments' />
              </h4>
            </Col>

            <Col style={{ textAlign: 'end' }} span={12}>
              <h4>
                {`${getCurrData.currencySymbol} 
                  ${
                    getData.totalPayments
                      ? formatDigits(getData.totalPayments, getDecimalPlaces)
                      : '0.00'
                  }`}
              </h4>
            </Col>
          </Row>

          {getData &&
            getData.salesPayments &&
            getData.salesPayments.length > 0 &&
            getData.salesPayments.map((qq, i) => {
              return (
                <Row key={i} style={{ marginLeft: '18px' }}>
                  <Col span={12}>
                    <h4 style={{ marginLeft: '12px' }}>{qq.name}</h4>
                  </Col>

                  <Col style={{ textAlign: 'end' }} span={12}>
                    <h4>
                      {`${getCurrData.currencySymbol} 
                      ${
                        getData.totalPayments
                          ? formatDigits(qq.total, getDecimalPlaces)
                          : '0.00'
                      }`}
                    </h4>
                  </Col>
                </Row>
              )
            })}

          {getData.totalReturn ? (
            <>
              <Divider />

              <Row>
                <Col span={12}>
                  <h4 style={{ marginLeft: '6px' }}>
                    <IntlMessages id='report.summary.totalreturn' />
                  </h4>
                </Col>

                <Col style={{ textAlign: 'end' }} span={12}>
                  <h4>
                    {`${getCurrData.currencySymbol} ${formatDigits(
                      getData.totalReturn,
                      getDecimalPlaces
                    )}`}
                  </h4>
                </Col>
              </Row>
            </>
          ) : (
            ''
          )}
          <Divider />
        </Card>

        <div className='Summary-Page-card'>
          <h2 className='mb-0'>
            <IntlMessages id='discount.reporting.payments' />
          </h2>

          <Table
            className='gx-table-responsive'
            columns={payColumns}
            dataSource={
              getData.payments && getData.payments.length > 0
                ? getData.payments
                : []
            }
            pagination={false}
          />
        </div>

        <div className='Summary-Page-card mt-4'>
          <h2 className='mb-0'>
            <IntlMessages id='discount.reporting.cashmove' />
          </h2>

          <Table
            className='gx-table-responsive'
            columns={cashColumns}
            dataSource={getCashMove}
            pagination={false}
          />
        </div>

        {(onAccList.length > 0 ||
          onAccPaid.length > 0 ||
          layByList.length > 0 ||
          layByPaid.length > 0 ||
          returnSales.length > 0) && (
          <>
            <h1 className='custom-head-reprt' style={{ marginTop: 10 }}>
              <IntlMessages id='report.summary.accsa' />
            </h1>

            {layByList.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <h3 className='' style={{ marginTop: 10 }}>
                  <IntlMessages id='report.summary.layby' />:
                </h3>
                <Table
                  className='gx-table-responsive'
                  columns={accColumns}
                  dataSource={layByList}
                  pagination={false}
                />
              </div>
            )}

            {layByPaid.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <h3 className='' style={{ marginTop: 10 }}>
                  <IntlMessages id='report.summary.laubyapy' />:
                </h3>
                <Table
                  className='gx-table-responsive'
                  columns={accColumns}
                  dataSource={layByPaid}
                  pagination={false}
                />
              </div>
            )}

            {onAccList.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <h3 className='' style={{ marginTop: 10 }}>
                  <IntlMessages id='report.summary.accstated' />:
                </h3>
                <Table
                  className='gx-table-responsive'
                  columns={accColumns}
                  dataSource={onAccList}
                  pagination={false}
                />
              </div>
            )}

            {onAccPaid.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <h3 className='' style={{ marginTop: 10 }}>
                  <IntlMessages id='report.summary.accpay' />:
                </h3>
                <Table
                  className='gx-table-responsive'
                  columns={accColumns}
                  dataSource={onAccPaid}
                  pagination={false}
                />
              </div>
            )}

            {returnSales.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <h3 className='' style={{ marginTop: 10 }}>
                  <IntlMessages id='report.summary.returnsales' />:
                </h3>
                <Table
                  className='gx-table-responsive'
                  columns={accColumns}
                  dataSource={returnSales}
                  pagination={false}
                />
              </div>
            )}
          </>
        )}

        {getData && (getData.openingNote || getData.closingNote) && (
          <div style={{ marginBottom: 12 }}>
            <h1
              className='custom-head-reprt'
              style={{ marginTop: 10, marginBottom: 12 }}
            >
              NOTE:
            </h1>

            {getData && getData.openingNote && (
              <div style={{ marginBottom: 6, background: '#fff', padding: 12 }}>
                <h3 style={{ marginTop: 10, marginBottom: 6 }}>
                  Opening Note:
                </h3>
                <p>{getData.openingNote}</p>
              </div>
            )}
            {getData && getData.closingNote && (
              <div style={{ marginBottom: 6, background: '#fff', padding: 12 }}>
                <h3 style={{ marginTop: 10, marginBottom: 6 }}>
                  Closing Note:
                </h3>
                <p>{getData.closingNote}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}
export default Summary
